// extracted by mini-css-extract-plugin
export var body = "styles-module--body--4Fy38";
export var address = "styles-module--address--7Hymp";
export var additional_links = "styles-module--additional_links--L9aqH";
export var offices_links = "styles-module--offices_links--PWLmV";